import React, { useState } from 'react';
import { Globe, Database, Truck, Map as MapIcon } from 'lucide-react';
import { DeliveryProvider, SystemConfig } from '../../types';
import { IntegrationSubTabGoogle } from './IntegrationSubTabGoogle';
import { SettingsTabHere } from './SettingsTabHere';
import { IntegrationSubTabPDVs } from './IntegrationSubTabPDVs';
import { IntegrationSubTabOpenDelivery } from './IntegrationSubTabOpenDelivery';

interface Props {
   config: SystemConfig;
   setConfig: (config: SystemConfig) => void;
   providers: DeliveryProvider[];
   storeId?: string | null;
}

type SubTab = 'google' | 'here' | 'pdvs' | 'opendelivery';

export const SettingsTabGoogle: React.FC<Props> = ({ config, setConfig, providers, storeId }) => {
   const [activeSubTab, setActiveSubTab] = useState<SubTab>('google');

   return (
      <div className="h-full flex flex-col animate-in fade-in duration-300">

         {/* Navegação Estilo Browser */}
         <div className="flex items-center gap-1 bg-card-bg p-1.5 rounded-2xl border border-border-dim mb-8 w-fit shrink-0">
            <button
               type="button"
               onClick={() => setActiveSubTab('google')}
               className={`px-6 py-2.5 rounded-xl text-xs font-black uppercase tracking-widest transition-all flex items-center gap-2 ${activeSubTab === 'google' ? 'bg-sal-cyber-teal text-badge-text-inv shadow-lg' : 'text-text-muted hover:bg-bg-main/50 hover:text-text-primary'}`}
            >
               <Globe className="w-4 h-4" /> Infra & Google
            </button>
            <button
               type="button"
               onClick={() => setActiveSubTab('here')}
               className={`px-6 py-2.5 rounded-xl text-xs font-black uppercase tracking-widest transition-all flex items-center gap-2 ${activeSubTab === 'here' ? 'bg-sal-cyber-teal text-badge-text-inv shadow-lg' : 'text-text-muted hover:bg-bg-main/50 hover:text-text-primary'}`}
            >
               <MapIcon className="w-4 h-4" /> HERE Maps
            </button>
            <button
               type="button"
               onClick={() => setActiveSubTab('pdvs')}
               className={`px-6 py-2.5 rounded-xl text-xs font-black uppercase tracking-widest transition-all flex items-center gap-2 ${activeSubTab === 'pdvs' ? 'bg-sal-cyber-teal text-badge-text-inv shadow-lg' : 'text-text-muted hover:bg-bg-main/50 hover:text-text-primary'}`}
            >
               <Database className="w-4 h-4" /> PDVs & Entradas
            </button>
            <button
               type="button"
               onClick={() => setActiveSubTab('opendelivery')}
               className={`px-6 py-2.5 rounded-xl text-xs font-black uppercase tracking-widest transition-all flex items-center gap-2 ${activeSubTab === 'opendelivery' ? 'bg-sal-cyber-teal text-badge-text-inv shadow-lg' : 'text-text-muted hover:bg-bg-main/50 hover:text-text-primary'}`}
            >
               <Truck className="w-4 h-4" /> Open Delivery
            </button>
         </div>

         {/* Área de Conteúdo Modular */}
         <div className="flex-1 overflow-y-auto pr-2 no-scrollbar pb-20">
            {activeSubTab === 'google' && (
               <IntegrationSubTabGoogle config={config} setConfig={setConfig} />
            )}
            {activeSubTab === 'here' && (
               <SettingsTabHere config={config} setConfig={setConfig} />
            )}
            {activeSubTab === 'pdvs' && (
               <IntegrationSubTabPDVs config={config} setConfig={setConfig} storeId={storeId || undefined} />
            )}
            {activeSubTab === 'opendelivery' && (
               <IntegrationSubTabOpenDelivery config={config} setConfig={setConfig} providers={providers} storeId={storeId || undefined} />
            )}
         </div>
      </div>
   );
};
